import styled from 'styled-components';
import { Breakpoints } from '../../styled/constants';
import { PlaceholderBlock } from '../../styled/placeholders.styled';

export const GoogleMapContainer = styled.div`
  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    position: relative;
    overflow: hidden;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    border-radius: 5px;
    overflow: hidden;
  }
`;

export const MapPlaceholderBlock = styled(PlaceholderBlock)`
  @media screen and (min-width: ${Breakpoints.tablet}px) {
    height: 660px;
  }
`;
